import {
  isClimateMonitoringSignalResult,
  isFinanceMonitoringSignalResult,
  isOwnershipMonitoringSignalResult,
  isRegulationMonitoringSignalResult,
  isReputationMonitoringSignalResult,
} from 'constants/interfaces/IMonitoringSignalResult';

import type { IScenarioFormInitialData } from 'components/AddScenarioSidebar/interfaces/IAddScenarioSidebar';
import type { TMonitoringAnySignalResult } from 'constants/interfaces/IMonitoringSignalResult';

export const MONITORING_IMPACT_BRIDGE_DEFAULT_AFFECTED_PERIOD = 1;
export const MONITORING_IMPACT_BRIDGE_DEFAULT_AFFECTED_PERIOD_UNIT = 'year';
export const MONITORING_IMPACT_BRIDGE_DEFAULT_PRODUCTIVITY_IMPACT = -50;

export interface IBuildMonitoringImpactScenarioInitialDataParams {
  scenarioName: string,
  unitIds: number[],
}

export const buildMonitoringImpactScenarioInitialData = ({
  scenarioName,
  unitIds,
}: IBuildMonitoringImpactScenarioInitialDataParams): IScenarioFormInitialData => ({
  name: scenarioName,
  affectedPeriod: MONITORING_IMPACT_BRIDGE_DEFAULT_AFFECTED_PERIOD,
  affectedPeriodUnit: MONITORING_IMPACT_BRIDGE_DEFAULT_AFFECTED_PERIOD_UNIT,
  productivityImpact: MONITORING_IMPACT_BRIDGE_DEFAULT_PRODUCTIVITY_IMPACT,
  unitIds: Array.from(new Set(unitIds)).filter((unitId) => Number.isInteger(unitId) && unitId > 0),
});

export const shouldShowMonitoringImpactScenarioCta = (
  results: TMonitoringAnySignalResult | null | undefined,
  unitIds: number[],
): boolean => {
  const hasEligibleUnits = unitIds.some((unitId) => Number.isInteger(unitId) && unitId > 0);

  if (!hasEligibleUnits) {
    return false;
  }

  if (isRegulationMonitoringSignalResult(results)) {
    return (
      results.summary.high_impact_count + results.summary.critical_impact_count
    ) > 0;
  }

  if (isFinanceMonitoringSignalResult(results) || isOwnershipMonitoringSignalResult(results)) {
    return Boolean(results.summary?.high_risk_count && results.summary.high_risk_count > 0);
  }

  if (isClimateMonitoringSignalResult(results)) {
    return Boolean(results.summary?.high_risk_count && results.summary.high_risk_count > 0);
  }

  if (!isReputationMonitoringSignalResult(results)) {
    return false;
  }

  return Boolean(results.summary?.high_risk_count && results.summary.high_risk_count > 0);
};
